module.exports = __webpack_public_path__ + "img/code-play.f6906912.svg";